import styled, { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
/* Box sizing rules */
:root{
  --toastify-color-progress-success: ${props => props.theme.colors.primary};
  --toastify-color-progress-error: ${props => props.theme.colors.red};
  --toastify-icon-color-success: ${props => props.theme.colors.primary};
  --toastify-icon-color-error: ${props => props.theme.colors.red};
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

*{
  font-family: ${props => props.theme.font};
}

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
    font-family: ${props => props.theme.font};
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;  
    vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
    display: block;
}
body {
    line-height: 1;
}
ol, ul {
    list-style: none;
}
blockquote, q {
    quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
    content: '';
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

button {
  background: none;
  border: none;
}




`
